// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2jetF","footer":"ChangeClinic_footer__3zVDE"};